// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { BankDetailsDrawerFooter } from '@client/banks/layouts/bank-details-drawer-footer';
import { BankDetailsDrawerHeader } from '@client/banks/layouts/bank-details-drawer-header';
import { List } from '@mui/material';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import styles from './bank-details-drawer.module.css';
import { useBankDetailsDrawer } from './use-bank-details-drawer';

export const BankDetailsDrawer = defineComponent({
  displayName: 'BankDetailsDrawer',
  useSetup: useBankDetailsDrawer,
  View: ({
    DrawerRenderer,
    institution,
    title,
    description,
    onClose,
    onDelete,
    onSave,
    isSaveDisabled,
    isSaveLoading,
    children,
  }) => (
    <DrawerRenderer
      anchor="right"
      PaperProps={{
        classes: {
          root: styles['drawer-paper'],
        },
        sx: { height: '100%', maxHeight: '100vh' },
      }}
      data-testid="bank-details-drawer"
    >
      <List dense disablePadding className={styles['drawer-list']}>
        <BankDetailsDrawerHeader
          title={title}
          description={description}
          onClose={onClose}
        />

        <div className={styles['drawer-body']}>{children}</div>

        {!children ? <div className={styles['section-spacer']} /> : null}

        <BankDetailsDrawerFooter
          institution={institution}
          onClose={onClose}
          onDelete={onDelete}
          onSave={onSave}
          isSaveDisabled={isSaveDisabled}
          isSaveLoading={isSaveLoading}
        />
      </List>
    </DrawerRenderer>
  ),
});
